import { Card, CardContent } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { IntegrationEnvVariable } from '@/entities/integrations';

import { EnvVariablesSection } from './EnvVariablesSection';

type Props = {
  envVariables: IntegrationEnvVariable[];
};

export const EnvVariablesTab: FC<Props> = ({ envVariables }) => {
  const { t } = useTranslation(['integrations', 'common']);

  if (envVariables.length === 0) {
    return (
      <Card>
        <CardContent className="text-muted-foreground">{t('common:emptyTable')}</CardContent>
      </Card>
    );
  }

  return <EnvVariablesSection envVariables={envVariables} />;
};
